import { FC, Fragment, useState } from 'react'
import CardHeading from '../headings/card'
import Column from '@components/column'
import {
  StyleCard,
  StyleCardHeader,
  StyleWeekDay,
  StyleWeekFilterWrapper,
  StyleWeekWrapper,
} from './style'
import { addDays, format } from 'date-fns'
import Typography from '@components/typography'
import Svg from '@components/svg'
import { Helper } from '@utils'
import Calendar from './calendar'
interface AppointmentScheduleFilterProps {
  onChange?: (date: any) => void
  title?: string
  date?: Date
}
const AppointmentScheduleFilter: FC<AppointmentScheduleFilterProps> = ({
  onChange,
  title = 'Appointment Schedule',
  date = new Date(),
}) => {
  const currentDate = format(new Date(date), 'yyyy-MM-dd')
  const [visible, setVisible] = useState<boolean>(false)
  const [activeDate, setActiveDate] = useState<string>(currentDate)
  const [startDate, setStartDate] = useState<string>(currentDate)
  const dates = Helper.getNext7Dates(startDate)

  const handleClickPrev = () => {
    const date = addDays(dates[0], -7)
    setStartDate(date)
  }

  const handleClickNext = () => {
    const date = addDays(dates[dates.length - 1], 1)
    setStartDate(date)
  }

  const handleChangeDate = (event: any) => {
    const id = (event.target as HTMLElement)
      .closest('[data-id]')
      ?.getAttribute('data-id')

    if (id) {
      setActiveDate(id)
      onChange?.(id)
    }
  }

  const handleClickCalendar = () => {
    setVisible(true)
  }

  return (
    <>
      <Column rowGap={15}>
        <CardHeading title={title} />
        <StyleCard>
          <StyleCardHeader>
            <StyleWeekFilterWrapper>
              <Column onClick={handleClickPrev}>
                <Svg svg="prevChervon" color={'primary'} />
              </Column>
              {!!dates[0] && (
                <Typography
                  content={`${format(dates[0], 'MMM dd')} - ${format(dates[dates?.length - 1], 'MMM dd')}`}
                  size={14}
                  tc={'primary'}
                />
              )}

              <Column onClick={handleClickNext}>
                <Svg svg="nextChervon" color={'primary'} />
              </Column>
            </StyleWeekFilterWrapper>
            <Column onClick={handleClickCalendar}>
              <Svg svg="calendar" />
            </Column>
          </StyleCardHeader>
          <StyleWeekWrapper onClick={handleChangeDate}>
            {dates?.map((date: any) => {
              const isActive = activeDate == date
              return (
                <Fragment key={date}>
                  <StyleWeekDay isActive={isActive} data-id={date}>
                    <Typography
                      content={format(date, 'eee')}
                      size={14}
                      tc={!!isActive ? 'white' : 'text'}
                    />
                    {format(date, 'dd')}
                  </StyleWeekDay>
                </Fragment>
              )
            })}
          </StyleWeekWrapper>
        </StyleCard>
      </Column>
      {!!visible && <Calendar setVisible={setVisible} visible={visible} />}
    </>
  )
}

export default AppointmentScheduleFilter
